import {Component, forwardRef, Inject, ViewChild} from '@angular/core';
import {
  AlertController, LoadingController, NavController, NavParams, Platform, Searchbar,
  ViewController
} from 'ionic-angular';
import {EbsWebService} from "../../services/ebsWebService";
import {PrintService} from "../../services/printService";
import {EbsComponentService} from "../../services/ebsComponentService";
declare var $;

@Component({
  selector: 'page-table',
  templateUrl: 'table.html',
  providers: [EbsWebService, PrintService]
})
export class Table {


  selectedItem: any;
  title: any;
  data: any;
  getTableDataUrl: string = "";
  searchword:string = "";
  beforeSearchData: any;
  showSpinner:boolean = false;
  table: any = null;
  @ViewChild("searchbar") searchbar:Searchbar;

  constructor(public navCtrl: NavController, public platform: Platform,
    public navParams: NavParams, private viewCtrl: ViewController,
    private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
    public loadingCtrl: LoadingController, public alertCtrl: AlertController,
    private printService: PrintService) {
    this.selectedItem = navParams.get('item');
    this.getTableDataUrl = navParams.get('actionURL');
  }

  ionViewDidLoad() {


    setTimeout(() => {
      if (typeof this.searchbar != "undefined" && !this.platform.is("tablet")) {
        this.searchbar.setFocus();
      }
    }, 1000);
  }



  ionViewWillEnter() {
    if (typeof this.getTableDataUrl != "undefined") {
      let loading = this.loadingCtrl.create({
        content: 'Bitte warten...'
      });
      loading.present();
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
      this._ebsWebService.postData(this.getTableDataUrl,postPayloadObject).subscribe(res => {

        this.data = res;
        this.beforeSearchData = this.data;
        this.title = res.Caption;

        loading.dismiss();
      });

      setTimeout(() => {
        $(document).ready(()=> {
          if (this.table != null) {
            this.table.destroy();
          }
          this.table = $('#dynamic-table').DataTable({
            "paging":   false,
            "info":     false,
            "searching": false,
            responsive: true,
            "order": []
          });
        } );
      }, 100);
    }
  }

  openPage(element) {
    if (this.table != null) {
      this.table.destroy();
    }
    let navParams = {
      title: element.ActionCaption,
      actionURL: element.Action,
      postParams: element.PostParameters
    };
    this._ebsComponentService.navigationController(element,navParams,this.navCtrl);
  }

  itemTapped(event, item) {
    alert("Funktion deaktiviert");
  }

  print() {
    this.printService.print('tablelist');
  }

  openAlert(action){
    if (typeof action != "undefined") {
      let alert = this.alertCtrl.create();
      alert.setTitle(action[0].ActionGroupName);
      action.forEach(element => {
        alert.addInput({
          type: 'radio',
          label: element.DisplayName,
          value: element.ActionUrl+"?"+element.PostParameters
        });
      });
      alert.addButton('Cancel');
      alert.addButton({
        text: 'Ok',
        handler: (data: any) => {
          let urlParts = data.split("?");
          this._ebsWebService.downloadFile(urlParts[0],urlParts[1]);
        }
      });

      alert.present();
    }
  }

  onSearchInput(){
    if (this.searchword.length>1) {
      this.showSpinner = true;

      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.data.SearchUrlPostParameters + this.searchword);
      this._ebsWebService.postData(this.data.SearchUrl,postPayloadObject).subscribe(res=>{
        this.showSpinner = false;
        if (res.ListItemNavigation[0].ListItemContent!=null && res.ListItemNavigation[0].ListItemContent.length != 0){

          this.data = res;
        }

      });

      setTimeout(function(){
        this.showSpinner = false;
      }, 10000)
    }
  }

  onSearchClear(){
    this.searchword="";
    this.data = this.beforeSearchData;
  }

}



// WEBPACK FOOTER //
// ./src/pages/table/table.ts